import { Fragment } from 'react';

import { CodeSpan } from '../CodeSpan';

import styles from './RatioMetricDefinitionBox.module.css';

/**
 * Returns the aggregation label for one leg of a ratio metric definition,
 * e.g. "Count", "Sum", "Average", or "Count Distinct".
 */
export function getRatioAggLabel(unitAggType?: string, isNumeric?: boolean): string {
  if (unitAggType === 'count_distinct') {
    return 'Count Distinct';
  }
  if (isNumeric && unitAggType === 'sum') {
    return 'Sum';
  }
  if (isNumeric && unitAggType === 'average') {
    return 'Average';
  }
  return 'Count';
}

export type RatioMetricDefinitionBoxProps = {
  numeratorAggLabel: string;
  numeratorAggColumn?: string;
  denominatorAggLabel: string;
  denominatorAggColumn?: string;
  units: string[];
  id?: string;
};

function TermRow({
  aggLabel,
  aggColumn,
  termLabel,
  units,
}: {
  aggLabel: string;
  aggColumn?: string;
  termLabel: string;
  units: string[];
}) {
  return (
    <div className={styles.termRow}>
      <span className={styles.aggLabel}>{aggLabel}</span>
      {aggColumn && (
        <>
          <span>on</span>
          <span className={styles.aggLabel}>{aggColumn}</span>
        </>
      )}
      <span>{termLabel} events per</span>
      {units.length === 0 ? (
        <CodeSpan textValue="[analysis unit]" />
      ) : (
        units.map((unit, i) => (
          <Fragment key={unit}>
            {i > 0 && <span>{i === units.length - 1 ? 'or' : ','}</span>}
            <CodeSpan textValue={unit} />
          </Fragment>
        ))
      )}
    </div>
  );
}

export function RatioMetricDefinitionBox({
  numeratorAggLabel,
  numeratorAggColumn,
  denominatorAggLabel,
  denominatorAggColumn,
  units,
  id,
}: RatioMetricDefinitionBoxProps) {
  return (
    <div className={styles.definitionBox} id={id}>
      <div className={styles.definitionContent}>
        <TermRow aggLabel={numeratorAggLabel} aggColumn={numeratorAggColumn} termLabel="numerator" units={units} />
        <div className={styles.definitionDivider} />
        <TermRow
          aggLabel={denominatorAggLabel}
          aggColumn={denominatorAggColumn}
          termLabel="denominator"
          units={units}
        />
      </div>
    </div>
  );
}
